<script setup>
import { useToggle } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import { provideDropdownContext } from './provider.js';

defineProps({
  // Optional positioning for the menu panel (e.g. "left-0 top-full mt-1").
  // Empty keeps legacy static-position behavior used by FilterSelect etc.
  menuClass: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close']);
const [isOpen, toggle] = useToggle(false);

const closeMenu = () => {
  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

provideDropdownContext({
  isOpen,
  toggle,
  closeMenu,
});
</script>

<template>
  <div
    v-on-click-outside="closeMenu"
    class="relative"
    :class="{ 'z-50': isOpen }"
  >
    <slot name="trigger" :is-open :toggle="() => toggle()" />
    <div v-if="isOpen" class="absolute z-50" :class="menuClass">
      <slot />
    </div>
  </div>
</template>
